import React from 'react';
import { Box } from '@mui/material';
import ItemReportByParty from '../../components/Reports/ItemReportByParty';

const ItemReportByPartyPage: React.FC = () => {
  return (
    <Box>
      <ItemReportByParty type="ITEM_REPORT_BY_PARTY" />
    </Box>
  );
};

export default ItemReportByPartyPage;
